import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'app-property-insurance',
  templateUrl: './property-insurance.component.html',
  styleUrls: ['./property-insurance.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PropertyInsuranceComponent implements OnInit {
  @Input() MatterPropertyDetailsForm: FormGroup;
  @Input() errorWarningData: any;
  @Input() toolTipList: any;
  toolTipPostion = 'above';
  @Input() testBool;
  constructor(public datepipe: DatePipe) {}

  ngOnInit(): void {}

  ResolutionDatepicker(type: string, event: MatDatepickerInputEvent<Date>) {
    this.MatterPropertyDetailsForm.controls['INSURANCEEXPIRYDATE'].setValue(
      this.datepipe.transform(event.value, 'dd/MM/yyyy'),
    );
  }
}
